import cloneDeep from 'lodash.clonedeep';

export const mapSceneElementIdsToElements = (scribe, scene) => {
  const sceneElementIds = scene.elementIds;
  const sceneElements = sceneElementIds.map(elId => scribe.elements.find(el => el.id === elId));
  return sceneElements;
};

export const mapActiveSceneElementIdsToElements = scribe => {
  return mapSceneElementIdsToElements(scribe, scribe.scenes.find(scene => scene.active));
};

export const getSceneSettings = scene => {
  return cloneDeep(scene.settings);
};

export const getActiveSceneSettings = scribe => {
  return getSceneSettings(scribe.scenes.find(scene => scene.active));
};
